var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
import { Base } from "@studiometa/js-toolkit";
import { tns } from "tiny-slider/src/tiny-slider";
class HeroSlider extends Base {
  mounted() {
    tns({
      container: ".slider",
      items: 1,
      slideBy: "page",
      autoplay: true,
      controls: false,
      nav: true,
      navPosition: "bottom",
      autoplayButton: false,
      autoplayButtonOutput: false,
      mouseDrag: true
    });
  }
}
__publicField(HeroSlider, "config", {
  name: "HeroSlider"
});
export {
  HeroSlider as default
};


if (module.hot) {module.hot.accept(function(err) {
if (err) {
console.error(err);
}
});
}
